import { TrackInfo } from "../../model/track-info";
import { TrackActionResult } from "../../model/track-action-result";
import { RegistratioData } from "../../../../../model/registration-data";

export class MaritalStatusInvestActionV2 {

    public static execute(data: RegistratioData, track: TrackInfo[]): TrackActionResult {
        const id = data.maritalStatus.maritalStatus;
        const idConjuge = ['608', '612'];
        const filterId = idConjuge.find(x => x === id);
        const hasStepAddress = track.findIndex((page: TrackInfo) => page.pageId === 'address-adjunt') > -1;

        if (filterId !== undefined) {
            const trackInfo = new TrackInfo('spouse', ['marital-status', 'spouse']);
            return new TrackActionResult(data, trackInfo);
        }
        else if (hasStepAddress) {
            const trackInfo = new TrackInfo('cep', ['address', 'cep']);
            return new TrackActionResult(data, trackInfo);
        }
        else {
            const indexPageSpouse = track.findIndex((page: TrackInfo) => page.pageId === 'spouse');
            const nextRouter = track.filter((_: TrackInfo, index: number) => index === indexPageSpouse + 1);
            const trackInfo = nextRouter.length === 0 ? undefined : new TrackInfo(nextRouter[0].pageId, nextRouter[0].path);

            return new TrackActionResult(data, trackInfo);
        }
    }
}